module.exports = __webpack_public_path__ + "img/SDG-07-EN-INVERTED.f8ffd610.png";